<template>
  <div class="form-group custom-control custom-radio"
    v-bind:class="{'has-error': errors.first(field.key)}">
    <small class="label" v-html="sanitizedFieldTitle"></small>
    <label class="form-item-group form-item-radio"
      v-for="option in field.options"
      v-bind:key="option.value">
      <input type="radio"
        class="custom-control-input"
        v-bind:name="field.key"
        v-bind:value="option.value"
        v-bind:checked="value === option.value"
        v-on:change="$emit('input', $event.target.value)"
        v-validate="validationRules"
        v-bind:data-vv-as="strippedFieldTitle"
        tabindex="1">
      <span class="custom-control-label">
        {{ option.title }}
      </span>
      <small class="label" v-html="option.help_text"></small>
    </label>
    <small class="form-help-text" v-html="sanitizedHelpText"></small>
    <span class="invalid-feedback"
      v-if="errors.has(field.key)">
      {{ errors.first(field.key) }}
    </span>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * Radio Buttons
 * -- Implements v-model
 *
 * A field that renders a list of radio inputs.
 */
export default {
  name: 'RadioButtons',
  mixins: [
    InputMixin,
  ],
};
</script>
